import { Alert as DSAlert } from "@artprov/design-system";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

export default function Alert({
  description,
  variant = "success",
  topClass = "top-[90px]",
  rightClass = "right-[20px]",
  absolute = false,
  zIndexClass = "z-[10000]",
  className="w-[336px]",
  onClose,
  autoHideMs = 3000,
}) {
  const [visible, setVisible] = useState(true);
  const positionClass = absolute ? "absolute" : "fixed";

  const handleClose = () => {
    setVisible(false);
    if (typeof onClose === "function") onClose();
  };

  useEffect(() => {
    if (autoHideMs && autoHideMs > 0) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (typeof onClose === "function") onClose();
      }, autoHideMs);
      return () => clearTimeout(timer);
    }
  }, [autoHideMs, onClose]);

  if (!visible) return null;

  return (
    <div className={`${positionClass} ${topClass} ${rightClass} ${zIndexClass} ${className}`}>
      <DSAlert variant={variant} description={description} onClose={handleClose} />
    </div>
  );
}

Alert.propTypes = {
  description: PropTypes.string,
  variant: PropTypes.string,
  topClass: PropTypes.string,
  rightClass: PropTypes.string,
  absolute: PropTypes.bool,
  zIndexClass: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func,
  autoHideMs: PropTypes.number,
};